import { render } from "./sector-detail.vue?vue&type=template&id=db752c74&scoped=true"
import script from "./sector-detail.vue?vue&type=script&lang=js"
export * from "./sector-detail.vue?vue&type=script&lang=js"

import "./sector-detail.vue?vue&type=style&index=0&id=db752c74&lang=scss"
import "./sector-detail.vue?vue&type=style&index=1&id=db752c74&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db752c74"]])

export default __exports__